module.exports = __webpack_public_path__ + "img/auto4.15d9d28f.jpg";